import * as _ from 'lodash'
import React, { useCallback, useState } from 'react';
import * as actions from '../actions';
import componentServices from '../componentServices';
import valueFilters from '../valueFilters';
import util from '../util';
import jobNoteFactory, { IJobNote, JobNoteType } from '../models/jobNoteModel';
import { Expander, Popup, sortableComponent } from './sharedComponents';
import { getCollection, ModelCollection } from '../store';
import { IModelSet } from 'Scripts/modelSet';

const NoteContextMenu = ({ deleteAction }) => {
	const onDeleteClicked = () => {
		deleteAction();
	};

	return	(<div className="content scrollable">
		<ul className="menu">
			<li><a className="button icon iconLabel removeItem delete" onClick={ onDeleteClicked }><span>Delete</span></a></li>
		</ul>
	</div>);
};

class AddNoteTable extends React.Component<any,any> {
	constructor (props) {
		super(props);

		this.handleButtonClick = this.handleButtonClick.bind(this);
	}

	updateModel (autoSave, e) {
		e.preventDefault();

		const newVal = (autoSave) ? valueFilters.clean(e.target.value) : e.target.value;

		this.props.updateModel(note => {
			note.setAt('content', newVal);
		}, { autoSave: autoSave });
	}

	handleButtonClick (e) {
		e.preventDefault();

		const newVal = valueFilters.clean(this.props.note.content);

		if (_.isEmpty(newVal)) {
			return;
		}

		this.props.addNoteHandler();
	}

	render () {
		const { note } = this.props;

		return (
			<table className="compact notes" cellPadding="0" cellSpacing="0">
				<tbody>
					<tr>
						<td />
						<td className="note"><textarea placeholder="Add a Note" onChange={this.updateModel.bind(this, false)} onBlur={this.updateModel.bind(this, true)} value={note.viewValue('content')} /></td>
						<td className="action"><button className="icon iconOnly addItem" onClick={this.handleButtonClick} ><span /></button></td>
						<td />
					</tr>
				</tbody>
			</table>
		);
	}
}

const NoteTable = sortableComponent(class NoteTableInner extends React.Component<any,any> {
	handleClick (k, e) {
		e.preventDefault();
		this.props.updateSort(k);
	}

	getClassName (key) {
		return (key === this.props.sortKey) ? 'sorted' : '';
	}

	render () {
		const { list, deleteNote } = this.props;
		const rows:JSX.Element[] = [];

		list.forEach((note) => {
			rows.push(<NoteTableRow note={note} key={note.key} deleteNote={ deleteNote } />);
		});

		return (
			<table className="sortable" cellPadding="0" cellSpacing="0">
				<thead>
					<tr>
						<td />
						<td className={this.getClassName('dateCreated')} onClick={this.handleClick.bind(this, 'dateCreated')}>Date</td>
						<td className={this.getClassName('content')} onClick={this.handleClick.bind(this, 'content')}>Note</td>
						<td className={this.getClassName('addedBy')} onClick={this.handleClick.bind(this, 'addedBy')}>Added By</td>
						<td />
						<td />
					</tr>
				</thead>
				<tbody>
					{rows}
				</tbody>
			</table>
		);
	}
});

function NoteTableRow({ note, deleteNote }: { note: IJobNote & { addedBy: string }, deleteNote: (key:string) => void}) {

	const doDelete = useCallback(() => {
		deleteNote(note.key);
		actions.popModal();
	}, [note, deleteNote]);

	const handleContextClick = useCallback((e) => {
		const popup = <Popup target={e.target}><NoteContextMenu deleteAction={ doDelete } /></Popup>;

		actions.pushModal({ component: popup });
	}, [doDelete])

	return (
		<tr className="added">
			<td />
			<td className="date"><strong>{util.dateHelper.formatDate(note.dateCreated, { userFriendly: true })}</strong></td>
			<td className="note">{note.content}</td>
			<td className="addedBy">{note.addedBy}</td>
			<td className="action"><button className="icon iconOnly contextMenu" onClick={handleContextClick}><span /></button></td>
			<td />
		</tr>
	);
}

export default function JobNotes({ type, title, tooltipText, notes, updateNotes }: { type: JobNoteType, title: string, tooltipText: string, notes: IModelSet<IJobNote>, updateNotes: (updater: (notes: IModelSet<IJobNote>) => void, options: { autoSave: boolean}) => void }) {
	const createPendingNote = () => {
		return jobNoteFactory({ type });
	}
	const [pendingNote, setPendingNote] = useState<IJobNote>(createPendingNote);

	const addNoteHandler = useCallback(() => {
		updateNotes((notes: IModelSet<IJobNote>) => {
			notes.set(pendingNote.key, pendingNote);
			setPendingNote(createPendingNote());
		}, { autoSave: true });
	}, [updateNotes, pendingNote]);

	const deleteNote = useCallback((noteKey: string) => {
		updateNotes(notes => {
			notes.delete(noteKey);
		}, { autoSave: true });
	}, [updateNotes]);

	const updateNote = useCallback((key, updater, options) => {
		updateNotes(notes => {
			let note = notes.get(key);

			if ((!note) && (key === pendingNote.key)) {
				note = pendingNote;
				options.autoSave = false;
			}

			if (note) {
				updater(note);
			}
		}, options);
	}, [updateNotes]);

	const { store } = componentServices;
	const employees = getCollection({ store, collection: ModelCollection.employees });

	const list = _.map(notes, note => {
		const employee = employees.find(e => {
			return e.user.key === note.createdById;
		});

		return _.assign({ addedBy: (employee ? employee.fullName : 'Unknown') }, note.toDocument());
	});

	return (
		<Expander title={ title } tooltipText={ tooltipText} contentClassNames={['inner']} >
			<div>
				<AddNoteTable key={ pendingNote.key } note={pendingNote} addNoteHandler={addNoteHandler} updateModel={ (u, o) => updateNote(pendingNote.key, u, o)} />
				<NoteTable list={ list } initialSortKey="dateCreated" deleteNote={ deleteNote } updateModel={updateNote} />
			</div>
		</Expander>
	);
}